'use es6';

import { GEO_TARGETING_TEST_FLAG } from 'cookie-banner/constants/hspb';
export const addEventListener = (element, eventType, eventHandler, useCapture) => {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, useCapture);
    return;
  } else if (element.attachEvent) {
    element.attachEvent(`on${eventType}`, eventHandler);
    return;
  }
  element[`on${eventType}`] = eventHandler;
  return;
};
export const removeEventListener = (element, eventType, eventHandler, useCapture) => {
  if (element.removeEventListener) {
    element.removeEventListener(eventType, eventHandler, useCapture);
    return;
  } else if (element.detachEvent) {
    element.detachEvent(`on${eventType}`, eventHandler);
    return;
  }
  element.removeAttribute(`on${eventType}`);
  return;
};
export const getAndRemoveCallValueFromQueue = (queue, search) => {
  for (let i = 0; i < queue.length; i++) {
    const subArray = queue[i];
    if (!Array.isArray(subArray)) {
      continue;
    }
    if (subArray.length > 0 && subArray[0] === search) {
      queue.splice(i--, 1);
      return subArray[1] ? subArray[1] : null;
    }
  }
  return null;
};
export const findAndRemoveFunctionCallFromQueue = (queue, search) => {
  for (let i = 0; i < queue.length; i++) {
    const subArray = queue[i];
    if (!Array.isArray(subArray)) {
      continue;
    }
    if (subArray.length > 0 && subArray[0] === search) {
      queue.splice(i--, 1);
      return true;
    }
  }
  return false;
};
const isDebugEnabled = () => {
  return document.location.hash.indexOf('#hsdbg') > -1 || document.location.search.indexOf('hsdbg') > -1;
};
export const logError = e => {
  if (!isDebugEnabled() || !e) {
    return;
  }
  window.console.error(e);
};
export const logDebug = message => {
  if (!isDebugEnabled()) {
    return;
  }
  window.console.debug(message);
};
export const extractDomainFromHostName = host => {
  let parts = host.split('.');
  if (parts.length > 2) {
    parts = parts.slice(1);
  }
  return `.${parts.join('.')}`;
};
export const searchCallAndRemoveFunctionsFromQueue = (queue, searchValues, callback) => {
  if (!Array.isArray(queue)) {
    return;
  }
  for (let i = 0; i < queue.length; i++) {
    const subArray = queue[i];
    if (!Array.isArray(subArray) || subArray.length === 0) {
      continue;
    }
    const fnName = subArray[0];
    if (searchValues.indexOf(fnName) > -1) {
      callback(subArray);
      queue.splice(i--, 1);
    }
  }
};
export const startsWith = function startsWith(str, pattern) {
  if (pattern == null) {
    return false;
  }
  return str.substr(0, pattern.length) === pattern;
};
export const endsWith = function endsWith(str, pattern) {
  const sizeDiff = str.length - pattern.length;
  return sizeDiff >= 0 && str.lastIndexOf(pattern) === sizeDiff;
};
export const addClass = (element, klass) => {
  element.classList.add(klass);
};
export const removeClass = (element, klass) => {
  element.classList.remove(klass);
};
export const createHtmlElement = content => {
  const fragment = document.createDocumentFragment();
  const parentDiv = document.createElement('div');
  parentDiv.innerHTML = content;
  while (parentDiv.firstChild) {
    fragment.appendChild(parentDiv.firstChild);
  }
  return fragment;
};
export const arrayContainsStr = (array, str) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i] === str) {
      return true;
    }
  }
  return false;
};
export const getTestingCountryCode = search => {
  const re = new RegExp(`${GEO_TARGETING_TEST_FLAG}=([a-zA-Z]{2})(&|$)`);
  const match = search.match(re);
  if (!match || match.length !== 3) {
    return null;
  }
  return match[1];
};